import React from "react";

const SvgMonitoraNeutralni = props => (
	<svg viewBox="0 0 206.71 104.08" {...props}>
		<defs>
			<linearGradient id="Nepojmenovaný_přechod_37" x1="159.76" y1="22.72" x2="47.05" y2="22.72" gradientUnits="userSpaceOnUse">
				<stop offset="0" stop-color="#59c9e7" />
				<stop offset="1" stop-color="#62b5e5" />
			</linearGradient>
			<linearGradient id="Nepojmenovaný_přechod_12" x1="152.56" y1="24.88" x2="199.08" y2="105.46" gradientUnits="userSpaceOnUse">
				<stop offset="0" stop-color="#ababab" />
				<stop offset="1" stop-color="#dfdede" />
			</linearGradient>
			<linearGradient id="Nepojmenovaný_přechod_20" x1="54.2" y1="24.79" x2="7.63" y2="105.46" gradientUnits="userSpaceOnUse">
				<stop offset="0" stop-color="#dfdede" />
				<stop offset="1" stop-color="#ababab" />
			</linearGradient>
		</defs>
		<g id="Vrstva_2" data-name="Vrstva 2">
			<g id="Vrstva_2-2" data-name="Vrstva 2">
				<path
					d="M94.62,94.46h0l.12-.73a.43.43,0,0,0,0,0c0-.21.06-.42.11-.63l.81-4.69,7.7-44.75,8.17,49.49c0,.21.07.41.1.62a1.7,1.7,0,0,1,0,.22l.09.57h0a7.89,7.89,0,0,1,.06,1,8.63,8.63,0,1,1-17.25,0A7.77,7.77,0,0,1,94.62,94.46Z"
					fill={"#45484a"}
				/>
				<path
					d="M67.15,45.38a68.51,68.51,0,0,1,72.51.06l20.1-28.7a103.41,103.41,0,0,0-112.71-.07Z"
					fill={`url('${window.location.href}#Nepojmenovaný_přechod_37')`}
				/>
				<path
					d="M162.94,18.89,142.85,47.58a68.49,68.49,0,0,1,28.82,53.47h35A103.26,103.26,0,0,0,162.94,18.89Z"
					fill={`url('${window.location.href}#Nepojmenovaný_přechod_12')`}
				/>
				<path
					d="M43.87,18.83A103.23,103.23,0,0,0,0,101.05H35a67.88,67.88,0,0,1,20-46A69.1,69.1,0,0,1,64,47.51Z"
					fill={`url('${window.location.href}#Nepojmenovaný_přechod_20')`}
				/>
			</g>
		</g>
	</svg>
);

export default SvgMonitoraNeutralni;